import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const { t } = useLang();
  const [state, setState] = useState("checking");
  const sid = params.get("session_id");

  useEffect(() => {
    let tries = 0;
    let stop = false;
    const check = async () => {
      if (stop) return;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); refresh(); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); return; }
      } catch { /* retry */ }
      if (++tries >= 15) { setState("timeout"); return; }
      setTimeout(check, 2000);
    };
    check();
    return () => { stop = true; };
  }, [sid, refresh]);

  return (
    <div className="grid min-h-[calc(100vh-148px)] place-items-center px-4" data-testid="payment-success-page">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-10 text-center">
        {state === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-slate-400" /><p className="mt-5 font-semibold">{t("pay.checking")}</p></>}
        {state === "paid" && <><CheckCircle2 className="mx-auto h-12 w-12 text-emerald-500" /><h1 className="mt-5 text-2xl font-bold" data-testid="payment-confirmed">{t("pay.added")}</h1><p className="mt-2 text-sm text-slate-500">{t("pay.updated")}</p></>}
        {(state === "failed" || state === "timeout") && <><XCircle className="mx-auto h-12 w-12 text-red-500" /><h1 className="mt-5 text-2xl font-bold">{state === "failed" ? t("pay.notDone") : t("pay.stillProcessing")}</h1><p className="mt-2 text-sm text-slate-500">{state === "failed" ? t("pay.noCharge") : t("pay.refresh")}</p></>}
        <Button asChild className="mt-8 rounded-full" data-testid="payment-go-dashboard"><Link to="/painel">{t("pay.goDash")}</Link></Button>
      </div>
    </div>
  );
}
